import script from "./ClubDeals.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClubDeals.vue?vue&type=script&lang=ts&setup=true"

import "./ClubDeals.vue?vue&type=style&index=0&id=4490e248&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4490e248"]])

export default __exports__